import { ActionList, ActionMenu } from "@primer/react";
import { ChevronDownIcon } from "@primer/octicons-react";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCommonContext } from "../../contexts/common";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
type ComboboxNamHocProps = {
  isReadonly?: boolean;
  value?: string;
  onValueChanged: (id: string) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  width?: string;
  stylingMode?: "outlined" | "filled" | "underlined";
};
export const ComboboxNamHoc = (props: ComboboxNamHocProps) => {
  const dm_namhocs = useSelector(
    (state: RootState) => state.categorySource.dm_namhocs
  );
  let stylingMode = "outlined";
  if (props.stylingMode) stylingMode = props.stylingMode;
  const dispatch = useDispatch();
  useEffect(() => {
    if (dm_namhocs.length === 0)
      dispatch(actions.categorySource.loadNamHocStart());
  }, []);

  // Tự động chọn "2026 - 2027" nếu chưa có giá trị được chọn (thêm mới)
  useEffect(() => {
    if ((!props.value || props.value === "") && dm_namhocs.length > 0) {
      const defaultNamHoc = dm_namhocs.find((x: any) =>
        x.nam_hoc?.toString().includes("2026 - 2027") ||
        x.nam_hoc?.toString().includes("2026-2027")
      );
      if (defaultNamHoc) {
        props.onValueChanged(defaultNamHoc.nam_hoc);
      }
    }
  }, [dm_namhocs]); // eslint-disable-line react-hooks/exhaustive-deps
  const { translate } = useCommonContext();
  const dataSource = useMemo(() => {
    return dm_namhocs.map(x => ({ ...x, text: `${props.preText ?? ""}${x.nam_hoc}` }))
  }, [props.preText, dm_namhocs])
  const selectedData = useMemo(() => {
    if (props.value) {
      return dataSource.find(x => x.nam_hoc.toString() == props.value)
    }
    return undefined
  }, [dataSource, props.value])
  return (

    <ActionMenu>
      <ActionMenu.Button
        style={{ width: "100%" }}
        aria-label="Select school year"
        className="button-left"
        trailingAction={ChevronDownIcon}
        >
        {selectedData ? selectedData.text : translate("NamHocSelecteBox.PlaceHolder")}
        
      </ActionMenu.Button>
      <ActionMenu.Overlay width="small">
        <ActionList selectionVariant="single">
          {dataSource.map((item, index) => {
            return (
              <ActionList.Item key={item.nam_hoc} selected={props.value != undefined && item.nam_hoc.toString() === props.value}
                onSelect={() => {
                  if (!props.isReadonly) {
                    props.onValueChanged(item.nam_hoc)
                  }
                }}
              >
                {item.text}
              </ActionList.Item>
            );
          })}
        </ActionList>

      </ActionMenu.Overlay>
    </ActionMenu >
  );
};
